
const DefaultTranslation = {
    
    // Not Found Screen
    _environmentNotFoundDescription: {
        pt_br: "Não foi possível carregar as informações do sistema\nContate o suporte para análise",
        en_us: "Unable to load system information\nContact support for analysis",
        es_es: "No se puede cargar la información del sistema\nComuníquese con el soporte para el análisis"
    },


    // Remove Dialog
    _removeDialogDescription: {
        pt_br: "Deseja realmente excluir o registro selecionado?",
        en_us: "Do you really want to delete the selected record?",
        es_es: "¿Realmente desea eliminar el registro seleccionado?"
    },


    // Governance Dialog
    _changeGovernanceStatusTo: {
        pt_br: "Alterar status de governança para:",
        en_us: "Change governance status to:",
        es_es: "Cambiar el estado de gobierno a:"
    },

    _governanceDialogDisableDoNotDisturbDescription: {
        pt_br: "Deseja realmente desabilitar o status de \"não perturbe\" para a UH?",
        en_us: "Do you really want to disable the \"do not disturb\" status for the room?",
        es_es: "¿Realmente desea desactivar el estado \"no molestar\" de la habitación?"
    },

    _governanceDialogEnableDoNotDisturbDescription: {
        pt_br: "Deseja realmente habilitar o status de \"não perturbe\" para a UH?",
        en_us: "Do you really want to enable the \"do not disturb\" status for the room?",
        es_es: "¿Realmente desea habilitar el estado \"no molestar\" para la habitación?"
    },

    _governanceDialogDisableExecutionPriorityDescription: {
        pt_br: "Deseja realmente desabilitar a prioridade de execução para a UH?",
        en_us: "Do you really want to disable the execution priority for the room?",
        es_es: "¿Realmente desea desactivar la prioridad de ejecución de la habitación?"
    },

    _governanceDialogEnableExecutionPriorityDescription: {
        pt_br: "Deseja realmente habilitar a prioridade de execução para a UH?",
        en_us: "Do you really want to enable the execution priority for the room?",
        es_es: "¿Realmente desea habilitar la prioridad de ejecución de la habitación?"
    },

    _governanceDialogSaveShoppingCartDescription: {
        pt_br: "Deseja realmente realizar o lançamento dos itens na conta da reserva?",
        en_us: "Do you really want to post the items to the reserve account?",
        es_es: "¿Realmente quiere contabilizar las partidas en la cuenta de reserva?"
    },

    _governanceDialogGovernanceItemsPendingMarking: {
        pt_br: "Existem itens de governança obrigatórios pendentes de marcação",
        en_us: "There are mandatory governance items pending marking",
        es_es: "Hay puntos de gobernanza obligatorios pendientes de calificación"
    },

    _governanceDialogRemoveRoomBlockingDescription: {
        pt_br: "Deseja realmente excluir o bloqueio da UH?",
        en_us: "Do you really want to delete the room block?",
        es_es: "¿Realmente desea eliminar el bloqueo de habitaciones?"
    },

    _governanceDialogRemoveRoomBlockingAlertDescription: {
        pt_br: "Caso a UH possua bloqueios para os próximos dias, eles também serão removidos ao remover o bloqueio da data atual",
        en_us: "If the room has blocks for the next few days, they will also be removed when removing the block for the current date",
        es_es: "Si la habitación tiene bloqueos para los próximos días, también se eliminarán al eliminar el bloqueo de la fecha actual"
    },


    // Room blocking Dialog
    _roomBlockingDialogAddConfirmationDescription: {
        pt_br: "Ao adicionar este bloqueio, caso existam reservas vinculadas à UH no período selecionado, o vínculo entre a UH e essas reservas será removido automaticamente",
        en_us: "When adding this block, if there are reservations linked to the room in the selected period, the link between the room and these reservations will be automatically removed",
        es_es: "Al añadir este bloque, si existen reservas vinculadas a la habitación en el periodo seleccionado, automáticamente se eliminará la vinculación entre la habitación y dichas reservas"
    },

    _roomBlockingDialogPastDateDescription: {
        pt_br: "Essa data não pode ser selecionada pois é anterior à data atual",
        en_us: "This date cannot be selected as it is before the current date",
        es_es: "Esta fecha no se puede seleccionar ya que es anterior a la fecha actual"
    },

    _roomBlockingDialogRemovedDateDescription: {
        pt_br: "Data de bloqueio removida em {date} às {time} pelo usuário {user}",
        en_us: "Block date removed on {date} at {time} by user {user}",
        es_es: "Fecha de bloqueo eliminada el {date} a las {time} por el usuario {user}"
    },

    _roomBlockingDialogRemoveDescriptionSingleDate: {
        pt_br: "Deseja realmente excluir o bloqueio da data selecionada?",
        en_us: "Do you really want to delete the lock on the selected date?",
        es_es: "¿Realmente deseas eliminar el bloqueo en la fecha seleccionada?"
    },

    _roomBlockingDialogRemoveDescriptionMultipleDates: {
        pt_br: "Deseja realmente excluir o bloqueio das datas selecionadas?",
        en_us: "Do you really want to delete the block on the selected dates?",
        es_es: "¿Realmente deseas eliminar el bloqueo en las fechas seleccionadas?"
    },


    
    // Login Screen
    _loginScreenDescription: {
        pt_br: "Entre para continuar em",
        en_us: "Sign in to continue on",
        es_es: "Inicia sesión para continuar en"
    },


    // Logout Dialog
    _logoutDialogDescription: {
        pt_br: "Deseja realmente encerrar a sessão?",
        en_us: "Do you really want to log out?",
        es_es: "¿De verdad quieres cerrar la sesión?"
    },


    // Context
    // Auth
    _authContextHandleLoginEnterprisesExpiredError: {
        pt_br: "Todos os empreendimentos encontram-se com a licença expirada",
        en_us: "All enterprises have expired licenses",
        es_es: "Todas las empresas tienen licencias caducadas"
    },

    _authContextHandleLoginEnterprisesExpiresWarning: {
        pt_br: "A licença do empreendimento expirará em breve",
        en_us: "The enterprise license will expire soon",
        es_es: "La licencia de la empresa expirará pronto"
    },


    // Partner Pms
    // Filters
    _showOnlyRoomsAssignedToMe: {
        pt_br: "Mostrar apenas UHs atribuídas a mim",
        en_us: "Show only rooms assigned to me",
        es_es: "Mostrar solo las habitaciones asignadas a mí"
    },


    // Reports
    // Filters
    _hideZeroedTags: {
        pt_br: "Ocultar tags zeradas",
        en_us: "Hide zeroed tags",
        es_es: "Ocultar tags en cero"
    },

    _hideZeroedUsers: {
        pt_br: "Ocultar usuários zerados",
        en_us: "Hide zeroed users",
        es_es: "Ocultar usuarios en cero"
    },


    // Service Orders
    // Add Dialog
    _addServiceOrderDialogEnterpriseMinimumAttachmentsError: {
        pt_br: "Empreendimento requer que adicione ao menos {minimumNumber} anexo(s) na ordem de serviço",
        en_us: "Enterprise required to add at least {minimumNumber} attachment(s) to service order",
        es_es: "La empresa le exige que añada al menos {número mínimo} archivos adjuntos a la orden de servicio"
    },

    _addServiceOrderDialogDepartmentMinimumAttachmentsError: {
        pt_br: "Departamento requer que adicione ao menos {minimumNumber} anexo(s) na ordem de serviço",
        en_us: "Department required to add at least {minimumNumber} attachment(s) to service order",
        es_es: "El departamento le exige que añada al menos {número mínimo} anexo(s) a la orden de servicio"
    },

    _addServiceOrderDialogDescriptionMinimumLengthError: {
        pt_br: "Descrição requer ao menos {minimumLength} caracteres",
        en_us: "Description requires at least {minimumLength} characters",
        es_es: "La descripción requiere al menos {minimumLength} caracteres"
    },

    // View Dialog
    _changeStatusTo: {
        pt_br: "Alterar status para:",
        en_us: "Change status to:",
        es_es: "Cambiar el estado a:"
    },

    _serviceOrderDialogNotAllowAddCommentsDescription: {
        pt_br: "Não é possível adicionar novos comentários na ordem de serviço",
        en_us: "It is not possible to add new comments to the service order",
        es_es: "No se pueden añadir nuevos comentarios a la orden de servicio"
    },


    // Attachment Type Selector
    _attachmentTypeSelectorPopoverInvalidImageTypeSingle: {
        pt_br: "Imagem com formato inválido ({extensions})",
        en_us: "Image with invalid format ({extensions})",
        es_es: "Imagen con formato inválido ({extensions})"
    },

    _attachmentTypeSelectorPopoverInvalidImageTypeMultiple: {
        pt_br: "{amount} imagens possuem formato inválido ({extensions})",
        en_us: "{amount} images have an invalid format ({extensions})",
        es_es: "{amount} imágenes tienen un formato inválido ({extensions})"
    },

    _attachmentTypeSelectorPopoverInvalidVideoTypeSingle: {
        pt_br: "Vídeo com formato inválido ({extensions})",
        en_us: "Video with invalid format ({extensions})",
        es_es: "Video con formato inválido ({extensions})"
    },

    _attachmentTypeSelectorPopoverInvalidVideoTypeMultiple: {
        pt_br: "{amount} vídeos possuem formato inválido ({extensions})",
        en_us: "{amount} videos have an invalid format ({extensions})",
        es_es: "{amount} videos tienen un formato inválido ({extensions})"
    },

    _attachmentTypeSelectorPopoverInvalidAudioTypeSingle: {
        pt_br: "Áudio com formato inválido ({extensions})",
        en_us: "Audio with invalid format ({extensions})",
        es_es: "Audio con formato inválido ({extensions})"
    },

    _attachmentTypeSelectorPopoverInvalidAudioTypeMultiple: {
        pt_br: "{amount} áudios possuem formato inválido ({extensions})",
        en_us: "{amount} audio files have an invalid format ({extensions})",
        es_es: "{amount} audios tienen un formato inválido ({extensions})"
    },



    // Defaults messages
    _proceedActionAskDescription: {
        pt_br: "Deseja realmente prosseguir com a ação?",
        en_us: "Do you really want to proceed with the action?",
        es_es: "¿Realmente quieres continuar con la acción?"
    },



    // Defaults
    accessControl: {
        pt_br: "Controle de Acesso",
        en_us: "Access Control",
        es_es: "Controle de Acesso"
    },

    accessProfile: {
        pt_br: "Perfil de Acesso",
        en_us: "Access Profile",
        es_es: "Perfil de Acceso"
    },

    accessProfiles: {
        pt_br: "Perfis de Acesso",
        en_us: "Access Profiles",
        es_es: "Perfiles de Acceso"
    },

    accessToken: {
        pt_br: "Token de acesso",
        en_us: "Access token",
        es_es: "Token de acceso"
    },

    action: {
        pt_br: "Ação",
        en_us: "Action",
        es_es: "Acción"
    },

    actions: {
        pt_br: "Ações",
        en_us: "Actions",
        es_es: "Acciones"
    },

    active: {
        pt_br: "Ativo",
        en_us: "Active",
        es_es: "Activo"
    },

    add: {
        pt_br: "Adicionar",
        en_us: "Add",
        es_es: "Agregar"
    },

    addAttachments: {
        pt_br: "Adicionar anexos",
        en_us: "Add attachments",
        es_es: "Añadir anexos"
    },

    addRoomBlocking: {
        pt_br: "Adicionar bloqueio de UH",
        en_us: "Add room blocking",
        es_es: "Bloqueo de habitaciones"
    },

    addShortcuts: {
        pt_br: "Adicionar atalhos",
        en_us: "Add shortcuts",
        es_es: "Agregar atajos"
    },

    administrative: {
        pt_br: "Administrativo",
        en_us: "Administrative",
        es_es: "Administrativo"
    },

    adults: {
        pt_br: "Adultos",
        en_us: "Adults",
        es_es: "Adultos"
    },

    all: {
        pt_br: "Todos",
        en_us: "All",
        es_es: "Todo"
    },

    allowAllEnterprisesViewedInAnalyticalDashboard: {
        pt_br: "Permitir que todos os empreendimentos sejam vistos no dashboard analítico (Power BI)",
        en_us: "Allow all projects to be seen in the analytical dashboard (Power BI)",
        es_es: "Permitir que todos los proyectos se vean en el panel analítico (Power BI)"
    },

    allowAllEnterprisesViewedInFinancialDashboard: {
        pt_br: "Permitir que todos os empreendimentos sejam vistos no dashboard financeiro (Power BI)",
        en_us: "Allow all projects to be seen on the financial dashboard (Power BI)",
        es_es: "Permitir que todos los proyectos se vean en el panel financiero (Power BI)"
    },

    allowAllEnterprisesViewedInManagementDashboard: {
        pt_br: "Permitir que todos os empreendimentos sejam vistos no dashboard gerencial (Power BI)",
        en_us: "Allow all projects to be seen on the management dashboard (Power BI)",
        es_es: "Permitir que todos los proyectos se vean en el panel de gestión (Power BI)"
    },

    allowAllEnterprisesViewedInVacationCenterDashboard: {
        pt_br: "Permitir que todos os empreendimentos sejam vistos no dashboard da central de férias (Power BI)",
        en_us: "Allow all projects to be seen on the vacation center dashboard (Power BI)",
        es_es: "Permitir que todos los proyectos se vean en el panel del centro de vacaciones (Power BI)"
    },

    analyticalDashboard: {
        pt_br: "Dashboard Analítico",
        en_us: "Analytical Dashboard",
        es_es: "Panel Analítico"
    },

    analyticalDashboardUrl: {
        pt_br: 'Url do dashboard analítico (Power BI)',
        en_us: 'Analytical dashboard url (Power BI)',
        es_es: 'Url del panel analítico (Power BI)'
    },

    api: {
        pt_br: "API",
        en_us: "API",
        es_es: "API"
    },

    apply: {
        pt_br: "Aplicar",
        en_us: "Apply",
        es_es: "Aplicar"
    },

    approval: {
        pt_br: "Aprovação",
        en_us: "Approval",
        es_es: "Aprobación"
    },

    attachments: {
        pt_br: "Anexos",
        en_us: "Attachments",
        es_es: "Anexos"
    },

    attention: {
        pt_br: "Atenção",
        en_us: "Attention",
        es_es: "Atención"
    },

    audio: {
        pt_br: "Áudio",
        en_us: "Audio",
        es_es: "Audio"
    },

    available: {
        pt_br: "Disponível",
        en_us: "Available",
        es_es: "Disponible"
    },

    avatar: {
        pt_br: "Avatar",
        en_us: "Avatar",
        es_es: "Avatar"
    },

    average: {
        pt_br: "Média",
        en_us: "Average",
        es_es: "Promedio"
    },

    averageTime: {
        pt_br: "Tempo médio",
        en_us: "Average time",
        es_es: "Tiempo medio"
    },

    baseUrl: {
        pt_br: "Url base",
        en_us: "Base url",
        es_es: "Url base"
    },

    block: {
        pt_br: "Bloco",
        en_us: "Block",
        es_es: "Bloque"
    },

    blocked: {
        pt_br: "Bloqueado",
        en_us: "Blocked",
        es_es: "Bloqueado"
    },

    blockedAccess: {
        pt_br: "Acesso bloqueado",
        en_us: "Blocked access",
        es_es: "Acceso bloqueado"
    },

    blockRoom: {
        pt_br: "Bloquear UH",
        en_us: "Block room",
        es_es: "Bloquear la habitación"
    },

    blockingInformation: {
        pt_br: "Informações do bloqueio",
        en_us: "Blocking informations",
        es_es: "Información de bloqueo"
    },

    blockingType: {
        pt_br: "Tipo de bloqueio",
        en_us: "Blocking type",
        es_es: "Tipo de cerradura"
    },

    by: {
        pt_br: "Por",
        en_us: "By",
        es_es: "Por"
    },

    byStatus: {
        pt_br: "Por status",
        en_us: "By status",
        es_es: "Por el estado"
    },

    byPriority: {
        pt_br: "Por prioridade",
        en_us: "By priority",
        es_es: "Por prioridad"
    },

    cancel: {
        pt_br: "Cancelar",
        en_us: "Cancel",
        es_es: "Cancelar"
    },

    canceled: {
        pt_br: "Cancelado",
        en_us: "Canceled",
        es_es: "Cancelado"
    },

    category: {
        pt_br: "Categoria",
        en_us: "Category",
        es_es: "Categoría"
    },

    changeLog: {
        pt_br: "Log de alterações",
        en_us: "Change log",
        es_es: "Registro de cambios"
    },

    changedFrom: {
        pt_br: "Alterado de",
        en_us: "Changed from",
        es_es: "Cambiaron desde"
    },

    changeEnterprise: {
        pt_br: "Alterar empreendimento",
        en_us: "Change enterprise",
        es_es: "Cambio de empresa"
    },

    changeLanguage: {
        pt_br: "Alterar idioma",
        en_us: "Change the language",
        es_es: "Cambia el idioma"
    },

    changePassword: {
        pt_br: "Alterar senha",
        en_us: "Change password",
        es_es: "Cambiar contraseña"
    },

    changingDepartment: {
        pt_br: 'Alteração do departamento',
        en_us: 'Changing department',
        es_es: 'Cambiar el departamento'
    },

    changingDoNotDisturbStatus: {
        pt_br: "Alteração do status de \"não perturbe\"",
        en_us: "Changing \"do not disturb\" status",
        es_es: "Cambio de estado \"no molestar\""
    },

    changingEstimatedCompletionDate: {
        pt_br: 'Alteração da data de conclusão estimada',
        en_us: 'Changing estimated completion date',
        es_es: 'Cambiar el fecha estimada de finalización'
    },

    changingGovernanceStatus: {
        pt_br: "Alteração do status de governança",
        en_us: "Changing governance status",
        es_es: "Cambio de estatus de gobierno"
    },

    changingPriority: {
        pt_br: 'Alteração da prioridade',
        en_us: 'Changing priority',
        es_es: 'Cambiar la prioridad'
    },

    changingResponsible: {
        pt_br: 'Alteração do responsável',
        en_us: 'Changing responsible',
        es_es: 'Cambiar el responsable'
    },

    changingStartDate: {
        pt_br: 'Alteração da data de início',
        en_us: 'Changing start date',
        es_es: 'Cambiar el fecha de inicio'
    },
    
    changingStatus: {
        pt_br: 'Alteração do status',
        en_us: 'Changing status',
        es_es: 'Cambiar el estado'
    },

    checkIn: {
        pt_br: "Check-in",
        en_us: "Check-in",
        es_es: "Check-in"
    },

    checkInReservation: {
        pt_br: "Reserva check-in",
        en_us: "Check-in reservation",
        es_es: "Reserva check-in"
    },

    checkOut: {
        pt_br: "Check-out",
        en_us: "Check-out",
        es_es: "Check-out"
    },

    childrens: {
        pt_br: "Crianças",
        en_us: "Childrens",
        es_es: "Niños"
    },

    clean: {
        pt_br: "Limpo",
        en_us: "Clean",
        es_es: "Limpio"
    },

    clone: {
        pt_br: "Clonar",
        en_us: "Clone",
        es_es: "Clonar"
    },

    close: {
        pt_br: "Fechar",
        en_us: "Close",
        es_es: "Cerrar"
    },

    comments: {
        pt_br: "Comentários",
        en_us: "Comments",
        es_es: "Comentarios"
    },

    completed: {
        pt_br: "Concluído",
        en_us: "Completed",
        es_es: "Finalizado"
    },

    copyright: {
        pt_br: "© Copyright {date}. Todos os direitos reservados",
        en_us: "© Copyright {date}. All rights reserved",
        es_es: "© Copyright {date}. Todos los derechos reservados"
    },

    createdAt: {
        pt_br: "Criado em",
        en_us: "Created at",
        es_es: "Creado en"
    },

    createdBy: {
        pt_br: "Criado por",
        en_us: "Created by",
        es_es: "Creado por"
    },

    critical: {
        pt_br: "Crítica",
        en_us: "Critical",
        es_es: "Crítico"
    },

    currentPassword: {
        pt_br: "Senha atual",
        en_us: "Current password",
        es_es: "Contraseña actual"
    },

    dashboard: {
        pt_br: "Dashboard",
        en_us: "Dashboard",
        es_es: "Dashboard"
    },

    database: {
        pt_br: "Banco de dados",
        en_us: "Database",
        es_es: "Base de datos"
    },

    databaseName: {
        pt_br: "Nome do banco de dados",
        en_us: "Database name",
        es_es: "Nombre de la base de datos"
    },

    date: {
        pt_br: "Data",
        en_us: "Date",
        es_es: "Fecha"
    },

    dateAtTime: {
        pt_br: "{date} às {time}",
        en_us: "{date} at {time}",
        es_es: "{date} a las {time}"
    },

    dates: {
        pt_br: "Datas",
        en_us: "Dates",
        es_es: "Fechas"
    },

    datetime: {
        pt_br: "Data e hora",
        en_us: "Date and time",
        es_es: "Fecha y hora"
    },

    days: {
        pt_br: "Dias",
        en_us: "Days",
        es_es: "Días"
    },

    department: {
        pt_br: "Departamento",
        en_us: "Department",
        es_es: "Departamento"
    },

    departments: {
        pt_br: "Departamentos",
        en_us: "Departments",
        es_es: "Departamentos"
    },

    description: {
        pt_br: "Descrição",
        en_us: "Description",
        es_es: "Descripción"
    },

    developedBy: {
        pt_br: "Desenvolvido por",
        en_us: "Developed by",
        es_es: "Desarrollado por"
    },

    differentRooms: {
        pt_br: "UHs diferentes",
        en_us: "Different rooms",
        es_es: "Habitaciones diferentes"
    },

    differents: {
        pt_br: "Diferentes",
        en_us: "Differents",
        es_es: "Diferentes"
    },

    differentServiceOrders: {
        pt_br: "Ordens de serviço diferentes",
        en_us: "Different service orders",
        es_es: "Órdenes de servicio diferentes"
    },

    differentUsers: {
        pt_br: "Usuários diferentes",
        en_us: "Different users",
        es_es: "Usuarios diferentes"
    },

    dirty: {
        pt_br: "Sujo",
        en_us: "Dirty",
        es_es: "Sucio"
    },

    disable: {
        pt_br: "Desabilitar",
        en_us: "Disable",
        es_es: "Desactivar"
    },

    disabled: {
        pt_br: "Desabilitado",
        en_us: "Disabled",
        es_es: "Desactivado"
    },

    document: {
        pt_br: "Documento",
        en_us: "Document",
        es_es: "Documento"
    },

    doNotDisturb: {
        pt_br: "Não perturbe",
        en_us: "Do not disturb",
        es_es: "No molestar"
    },

    doNotDisturbDisabled: {
        pt_br: "Não perturbe desabilitado",
        en_us: "Do not disturb disabled",
        es_es: "No molestar desactivado"
    },

    doNotDisturbEnabled: {
        pt_br: "Não perturbe habilitado",
        en_us: "Do not disturb enabled",
        es_es: "No molestar habilitado"
    },

    edit: {
        pt_br: "Editar",
        en_us: "Edit",
        es_es: "Editar"
    },

    editDepartment: {
        pt_br: "Editar departamento",
        en_us: "Edit department",
        es_es: "Editar departamento"
    },

    editDoNotDisturbStatus: {
        pt_br: "Editar status de \"não perturbe\"",
        en_us: "Edit \"do not disturb\" status",
        es_es: "Editar estado de \"no molestar\""
    },

    editEstimatedCompletionDate: {
        pt_br: "Editar data de conclusão estimada",
        en_us: "Edit estimated completion date",
        es_es: "Editar fecha estimada de finalización"
    },

    editExecutionPriority: {
        pt_br: "Editar prioridade de execução",
        en_us: "Edit execution priority",
        es_es: "Editar prioridad de ejecución"
    },

    editGovernanceStatus: {
        pt_br: "Editar status de governança",
        en_us: "Edit governance status",
        es_es: "Editar estado de gobernanza"
    },

    editPriority: {
        pt_br: "Editar prioridade",
        en_us: "Edit priority",
        es_es: "Editar prioridad"
    },

    editResponsible: {
        pt_br: "Editar responsável",
        en_us: "Edit responsible",
        es_es: "Editar responsable"
    },

    editRoomObservations: {
        pt_br: "Editar observações da UH",
        en_us: "Edit room observations",
        es_es: "Editar observaciones de la habitacion"
    },

    editStartDate: {
        pt_br: "Editar data de início",
        en_us: "Edit start date",
        es_es: "Editar fecha de inicio"
    },

    editStatus: {
        pt_br: "Editar status",
        en_us: "Edit status",
        es_es: "Editar estado"
    },

    email: {
        pt_br: "E-mail",
        en_us: "Email",
        es_es: "Email"
    },

    emailConfiguration: {
        pt_br: 'Configuração de e-mail',
        en_us: 'Email configuration',
        es_es: 'Configuración de correo electrónico'
    },

    empty: {
        pt_br: "Vazio",
        en_us: "Empty",
        es_es: "Vacío"
    },

    enable: {
        pt_br: "Habilitar",
        en_us: "Enable",
        es_es: "Habilitar"
    },

    enabled: {
        pt_br: "Habilitado",
        en_us: "Enabled",
        es_es: "Habilitado"
    },

    endDate: {
        pt_br: "Data final",
        en_us: "End date",
        es_es: "Fecha final"
    },

    english: {
        pt_br: "Inglês",
        en_us: "English",
        es_es: "Inglés"
    },

    enterprise: {
        pt_br: "Empreendimento",
        en_us: "Enterprise",
        es_es: "Empresa"
    },

    enterprises: {
        pt_br: "Empreendimentos",
        en_us: "Enterprises",
        es_es: "Empresas"
    },

    estimatedCompletionDate: {
        pt_br: "Data de conclusão estimada",
        en_us: "Estimated completion date",
        es_es: "Fecha estimada de finalización"
    },

    excluded: {
        pt_br: "Excluído",
        en_us: "Excluded",
        es_es: "Excluido"
    },

    executed: {
        pt_br: "Executado",
        en_us: "Executed",
        es_es: "Ejecutado"
    },

    executedAt: {
        pt_br: "Executado em",
        en_us: "Executed at",
        es_es: "Ejecutado en"
    },

    executedBy: {
        pt_br: "Executado por",
        en_us: "Executed by",
        es_es: "Ejecutado por"
    },

    executionPriority: {
        pt_br: "Prioridade de execução",
        en_us: "Execution priority",
        es_es: "Prioridad de ejecución"
    },

    executionPriorityDisabled: {
        pt_br: "Prioridade de execução desabilitada",
        en_us: "Execution priority disabled",
        es_es: "Prioridad de ejecución desactivada"
    },

    executionPriorityEnabled: {
        pt_br: "Prioridade de execução habilitada",
        en_us: "Execution priority enabled",
        es_es: "Prioridad de ejecución habilitada"
    },

    expand: {
        pt_br: "Expandir",
        en_us: "Expand",
        es_es: "Ampliar"
    },

    expectedCheckIn: {
        pt_br: "Check-in previsto",
        en_us: "Expected check-in",
        es_es: "Check-in previsto"
    },

    expectedCheckInWithoutRoom: {
        pt_br: "Check-in previsto sem UH",
        en_us: "Expected check-in without room",
        es_es: "Check-in previsto sin habitación"
    },

    expectedCheckOut: {
        pt_br: "Check-out previsto",
        en_us: "Expected check-out",
        es_es: "Check-out previsto"
    },

    expectedOccupancy: {
        pt_br: "Ocupação prevista",
        en_us: "Expected occupancy",
        es_es: "Ocupación prevista"
    },

    expiration: {
        pt_br: "Expiração",
        en_us: "Expiration",
        es_es: "Expiración"
    },

    expired: {
        pt_br: "Expirado",
        en_us: "Expired",
        es_es: "Venció"
    },

    expiredAt: {
        pt_br: "Expirado em",
        en_us: "Expired at",
        es_es: "Venció a las"
    },

    expiresAt: {
        pt_br: "Expira em",
        en_us: "Expires at",
        es_es: "Caduca a las"
    },
    
    filter: {
        pt_br: "Filtrar",
        en_us: "Filter",
        es_es: "Filtrar"
    },

    filters: {
        pt_br: "Filtros",
        en_us: "Filters",
        es_es: "Filtros"
    },

    finalOccupation: {
        pt_br: "Ocupação final",
        en_us: "Final occupation",
        es_es: "Ocupación final"
    },

    finalStatus: {
        pt_br: "Status final",
        en_us: "Final status",
        es_es: "Estado final"
    },

    financialDashboard: {
        pt_br: 'Dashboard Financeiro',
        en_us: 'Financial Dashboard',
        es_es: 'Panel Financiero'
    },

    financialDashboardUrl: {
        pt_br: 'Url do dashboard financeiro (Power BI)',
        en_us: 'Financial dashboard url (Power BI)',
        es_es: 'Url del panel financiero (Power BI)'
    },

    floor: {
        pt_br: "Andar",
        en_us: "Floor",
        es_es: "Piso"
    },
    
    forgotPassword: {
        pt_br: "Esqueceu a senha?",
        en_us: "Forgot password?",
        es_es: "¿Olvido la contraseña?"
    },

    friday: {
        pt_br: "Sexta-feira",
        en_us: "Friday",
        es_es: "Viernes"
    },

    from: {
        pt_br: "De",
        en_us: "From",
        es_es: "De"
    },

    fullName: {
        pt_br: "Nome completo",
        en_us: "Fullname",
        es_es: "Nombre completo"
    },

    governance: {
        pt_br: "Governança",
        en_us: "Governance",
        es_es: "Gobernanza"
    },

    governanceItem: {
        pt_br: "Item de governança",
        en_us: "Governance item",
        es_es: "Elemento de gobernanza"
    },

    governanceItems: {
        pt_br: "Itens de governança",
        en_us: "Governance items",
        es_es: "Elementos de gobernanza"
    },

    governanceStatistics: {
        pt_br: "Estatísticas de governança",
        en_us: "Governance statistics",
        es_es: "Estadísticas de gobernanza"
    },

    governanceStatus: {
        pt_br: "Status de governança",
        en_us: "Governance status",
        es_es: "Estado de gobernabilidad"
    },

    governanceStatusAllowedToDisplayGovernanceItems: {
        pt_br: "Status de governança permitidos para exibir itens de governança",
        en_us: "Governance status allowed to display governance items",
        es_es: "Estado de gobernabilidad permitido para mostrar elementos de gobernanza"
    },

    guestType: {
        pt_br: "Tipo de hóspede",
        en_us: "Guest type",
        es_es: "Tipo de huésped"
    },

    guestTypes: {
        pt_br: "Tipos de hóspede",
        en_us: "Guest types",
        es_es: "Tipos de huésped"
    },

    high: {
        pt_br: "Alta",
        en_us: "High",
        es_es: "Alto"
    },

    housekeepingDetails: {
        pt_br: "Detalhes da arrumação",
        en_us: "Housekeeping details",
        es_es: "Detalles de la limpieza"
    },

    host: {
        pt_br: "Host",
        en_us: "Host",
        es_es: "Host"
    },

    id: {
        pt_br: "ID",
        en_us: "ID",
        es_es: "ID"
    },

    illustration: {
        pt_br: "Ilustração",
        en_us: "Illustration",
        es_es: "Ilustración"
    },

    image: {
        pt_br: "Imagem",
        en_us: "Image",
        es_es: "Imagen"
    },

    images: {
        pt_br: "Imagens",
        en_us: "Images",
        es_es: "Imágenes"
    },

    inactive: {
        pt_br: "Inativo",
        en_us: "Inactive",
        es_es: "Inactivo"
    },

    inactiveEnterprise: {
        pt_br: "Empreendimento inativo",
        en_us: "Inactive enterprise",
        es_es: "Empresa inactiva"
    },

    includedIn: {
        pt_br: "Incluído em",
        en_us: "Included in",
        es_es: "Incluido en"
    },

    informations: {
        pt_br: "Informações",
        en_us: "Informations",
        es_es: "Informaciones"
    },

    initialOccupation: {
        pt_br: "Ocupação inicial",
        en_us: "Initial occupation",
        es_es: "Ocupación inicial"
    },

    initialStatus: {
        pt_br: "Status inicial",
        en_us: "Initial status",
        es_es: "Estado inicial"
    },

    inProgress: {
        pt_br: "Em andamento",
        en_us: "In progress",
        es_es: "En curso"
    },

    inspection: {
        pt_br: "Inspeção",
        en_us: "Inspection",
        es_es: "Inspección"
    },

    interdicted: {
        pt_br: "Interditado",
        en_us: "Interdicted",
        es_es: "Interdicted"
    },

    inTidying: {
        pt_br: "Em arrumação",
        en_us: "In tidying",
        es_es: "En limpieza"
    },

    language: {
        pt_br: "Idioma",
        en_us: "Language",
        es_es: "Idioma"
    },

    launchItems: {
        pt_br: "Lançar itens",
        en_us: "Launch items",
        es_es: "Lanzar artículos"
    },

    launchRoomServiceItems: {
        pt_br: "Lançar itens de serviço de quarto",
        en_us: "Launch room service items",
        es_es: "Lanzar artículos de servicio de habitaciones"
    },

    legend: {
        pt_br: "Legenda",
        en_us: "Legend",
        es_es: "Leyenda"
    },

    logo: {
        pt_br: "Logo",
        en_us: "Logo",
        es_es: "Logotipo"
    },

    logon: {
        pt_br: "Entrar",
        en_us: "Log on",
        es_es: "Entrar"
    },

    logout: {
        pt_br: "Sair",
        en_us: "Logout",
        es_es: "Salir"
    },

    low: {
        pt_br: "Baixa",
        en_us: "Low",
        es_es: "Bajo"
    },

    mainGuest: {
        pt_br: "Hóspede principal",
        en_us: "Main guest",
        es_es: "Invitado principal"
    },

    maintenance: {
        pt_br: "Manutenção",
        en_us: "Maintenance",
        es_es: "Mantenimiento"
    },

    managementDashboard: {
        pt_br: 'Dashboard Gerencial',
        en_us: 'Management Dashboard',
        es_es: 'Panel de Gestión'
    },

    managementDashboardUrl: {
        pt_br: 'Url do dashboard gerencial (Power BI)',
        en_us: 'Management dashboard url (Power BI)',
        es_es: 'Url del panel de gestión (Power BI)'
    },

    medium: {
        pt_br: "Média",
        en_us: "Medium",
        es_es: "Medio"
    },

    minimumNumberAttachments: {
        pt_br: "Número mínimo de anexos",
        en_us: "Minimum number of attachments",
        es_es: "Número mínimo de anexos"
    },

    monday: {
        pt_br: "Segunda-feira",
        en_us: "Monday",
        es_es: "Lunes"
    },

    myProfile: {
        pt_br: "Meu Perfil",
        en_us: "My Profile",
        es_es: "Mi Perfil"
    },

    name: {
        pt_br: "Nome",
        en_us: "Name",
        es_es: "Nombre"
    },

    newPassword: {
        pt_br: "Nova senha",
        en_us: "New password",
        es_es: "Nueva contraseña"
    },

    no: {
        pt_br: "Não",
        en_us: "No",
        es_es: "No"
    },

    noAttachmentsFound: {
        pt_br: "Nenhum anexo encontrado",
        en_us: "No attachment found",
        es_es: "No se han encontrado anexos"
    },

    noCommentsFound: {
        pt_br: "Nenhum comentário encontrado",
        en_us: "No comments found",
        es_es: "No se encontraron comentarios"
    },

    noDescriptionFound: {
        pt_br: "Nenhuma descrição encontrada",
        en_us: "No description found",
        es_es: "No se encontró ninguna descripción"
    },

    noItemsFound: {
        pt_br: 'Nenhum item encontrado',
        en_us: 'No items found',
        es_es: 'No se encontraron artículos'
    },
    
    noRecordsFound: {
        pt_br: "Nenhum registro foi encontrado",
        en_us: "No records found",
        es_es: "No se encontraron registros"
    },
    
    noRoomBlockingsFound: {
        pt_br: 'Nenhum bloqueio de UH encontrado',
        en_us: 'No room blockings found',
        es_es: 'No se encontraron bloqueos de habitaciones'
    },

    noRoomsFound: {
        pt_br: 'Nenhuma UH encontrada',
        en_us: 'No rooms found',
        es_es: 'No se han encontrado habitaciones'
    },

    noServiceOrdersFound: {
        pt_br: 'Nenhuma ordem de serviço encontrada',
        en_us: 'No service order found',
        es_es: 'No se han encontrado órdenes de trabajo'
    },

    notExecuted: {
        pt_br: "Não executado",
        en_us: "Not executed",
        es_es: "No ejecutado"
    },

    noUrlConfiguredForPowerBiVisualization: {
        pt_br: "Nenhuma url configurada para visualização do Power BI",
        en_us: "No url configured for Power BI visualization",
        es_es: "No hay ninguna url configurada para la visualización de Power BI"
    },

    observations: {
        pt_br: "Observações",
        en_us: "Observations",
        es_es: "Observaciones"
    },

    occupancy: {
        pt_br: "Ocupação",
        en_us: "Occupancy",
        es_es: "Ocupación"
    },

    occupancyStatus: {
        pt_br: "Status de ocupação",
        en_us: "Occupancy status",
        es_es: "Estado de ocupación"
    },

    occupation: {
        pt_br: "Ocupação",
        en_us: "Occupation",
        es_es: "Ocupación"
    },

    occupied: {
        pt_br: "Ocupado",
        en_us: "Occupied",
        es_es: "Ocupado"
    },

    open: {
        pt_br: "Aberto",
        en_us: "Open",
        es_es: "Abierto"
    },

    operational: {
        pt_br: "Operacional",
        en_us: "Operational",
        es_es: "Operacional"
    },

    operator: {
        pt_br: "Operador",
        en_us: "Operator",
        es_es: "Operador"
    },

    ordering: {
        pt_br: "Ordenação",
        en_us: "Ordering",
        es_es: "Ordenar"
    },

    owner: {
        pt_br: "Proprietário",
        en_us: "Owner",
        es_es: "Propietario"
    },

    ownerReservation: {
        pt_br: "Reserva de proprietário",
        en_us: "Owner reservation",
        es_es: "Reserva de propietario"
    },

    parameters: {
        pt_br: "Parâmetros",
        en_us: "Parameters",
        es_es: "Parámetros"
    },

    partnerId: {
        pt_br: "ID do parceiro",
        en_us: "Partner ID",
        es_es: "Identificación del socio"
    },

    password: {
        pt_br: "Senha",
        en_us: "Password",
        es_es: "Contraseña"
    },

    pending: {
        pt_br: "Pendente",
        en_us: "Pending",
        es_es: "Pendiente"
    },

    permissions: {
        pt_br: "Permissões",
        en_us: "Permissions",
        es_es: "Permisos"
    },

    perRequest: {
        pt_br: "Por solicitação",
        en_us: "Per request",
        es_es: "Por solicitude"
    },

    perRoom: {
        pt_br: "Por UH",
        en_us: "Per room",
        es_es: "Por habitación"
    },

    perUser: {
        pt_br: "Por usuário",
        en_us: "Per user",
        es_es: "Por usuario"
    },

    print: {
        pt_br: "Imprimir",
        en_us: "Print",
        es_es: "Imprimir"
    },

    priority: {
        pt_br: "Prioridade",
        en_us: "Priority",
        es_es: "Prioridad"
    },

    properties: {
        pt_br: "Propriedades",
        en_us: "Properties",
        es_es: "Propiedades"
    },

    pointsOfSale: {
        pt_br: "Pontos de venda",
        en_us: "Points of sale",
        es_es: "Puntos de venta"
    },

    port: {
        pt_br: "Porta",
        en_us: "Port",
        es_es: "Puerta"
    },

    portuguese: {
        pt_br: "Português",
        en_us: "Portuguese",
        es_es: "Portugués"
    },

    preferences: {
        pt_br: "Preferências",
        en_us: "Preferences",
        es_es: "Preferencias"
    },

    recentlyAccessed: {
        pt_br: "Acessado recentemente",
        en_us: "Recently accessed",
        es_es: "Accedido recientemente"
    },

    records: {
        pt_br: "registros",
        en_us: "records",
        es_es: "registros"
    },

    recordsFound: {
        pt_br: "Registros encontrados",
        en_us: "Records found",
        es_es: "Registros encontrados"
    },

    recordsPerPage: {
        pt_br: "Registros por página",
        en_us: "Records per page",
        es_es: "Registros por página"
    },

    reduce: {
        pt_br: "Reduzir",
        en_us: "Reduce",
        es_es: "Reducir"
    },

    refresh: {
        pt_br: "Atualizar",
        en_us: "Refresh",
        es_es: "Actualizar"
    },

    remove: {
        pt_br: "Remover",
        en_us: "Remove",
        es_es: "Eliminar"
    },

    removeBlocking: {
        pt_br: "Remover bloqueio",
        en_us: "Remove blocking",
        es_es: "Eliminar el bloqueo"
    },

    removedAt: {
        pt_br: "Removido em",
        en_us: "Removed at",
        es_es: "Eliminado en"
    },

    repeatNewPassword: {
        pt_br: "Repita a nova senha",
        en_us: "Repeat the new password",
        es_es: "Repita la nueva contraseña"
    },

    reports: {
        pt_br: "Relatórios",
        en_us: "Reports",
        es_es: "Informes"
    },

    reproved: {
        pt_br: "Reprovado",
        en_us: "Reproved",
        es_es: "Reprobado"
    },

    requests: {
        pt_br: "Solicitações",
        en_us: "Requests",
        es_es: "Solicitudes"
    },

    requestsExecuted: {
        pt_br: "Solicitações executadas",
        en_us: "Requests executed",
        es_es: "Solicitudes ejecutadas"
    },

    requestsReproved: {
        pt_br: "Solicitações reprovadas",
        en_us: "Requests reproved",
        es_es: "Solicitudes reprobadas"
    },

    required: {
        pt_br: "Obrigatório",
        en_us: "Required",
        es_es: "Requerido"
    },

    requireMandatoryGovernanceItemsMarked: {
        pt_br: "Exigir a marcação dos itens obrigatórios de governança",
        en_us: "Require mandatory governance items to be marked",
        es_es: "Exigir que se marquen los elementos de gobernanza obligatorios"
    },

    reservation: {
        pt_br: "Reserva",
        en_us: "Reservation",
        es_es: "Reservación"
    },

    reservationObservations: {
        pt_br: "Observações da reserva",
        en_us: "Reservation observations",
        es_es: "Observaciones de reserva"
    },

    reservations: {
        pt_br: "Reservas",
        en_us: "Reservations",
        es_es: "Reservacións"
    },

    responsible: {
        pt_br: "Responsável",
        en_us: "Responsible",
        es_es: "Responsable"
    },

    roomBlocking: {
        pt_br: "Bloqueio de UHs",
        en_us: "Room blocking",
        es_es: "Bloqueo de habitaciones"
    },

    roomInformation: {
        pt_br: "Informações da UH",
        en_us: "Room informations",
        es_es: "Informaciónes de la habitación"
    },

    roomLog: {
        pt_br: "Log de UHs",
        en_us: "Room log",
        es_es: "Registro de habitaciones"
    },

    roomOverview: {
        pt_br: "Panorama de UHs",
        en_us: "Room overview",
        es_es: "Resumen de habitaciones"
    },

    roomService: {
        pt_br: "Serviço de quarto",
        en_us: "Room service",
        es_es: "Servicio de habitaciones"
    },

    roomStatus: {
        pt_br: "Status da UH",
        en_us: "Room status",
        es_es: "Estado de la habitación"
    },

    room: {
        pt_br: "UH",
        en_us: "Room",
        es_es: "Habitacion"
    },

    rooms: {
        pt_br: "UHs",
        en_us: "Rooms",
        es_es: "Habitaciones"
    },

    roomsExecuted: {
        pt_br: "UHs executadas",
        en_us: "Rooms executed",
        es_es: "Habitaciones ejecutadas"
    },

    roomsReproved: {
        pt_br: "UHs reprovadas",
        en_us: "Rooms reproved",
        es_es: "Habitaciones reprobadas"
    },

    roomType: {
        pt_br: "Tipo de UH",
        en_us: "Room type",
        es_es: "Tipo de habitación"
    },

    roomTypes: {
        pt_br: "Tipos de UH",
        en_us: "Room types",
        es_es: "Tipos de habitación"
    },

    saturday: {
        pt_br: "Sábado",
        en_us: "Saturday",
        es_es: "Sábado"
    },

    save: {
        pt_br: "Salvar",
        en_us: "Save",
        es_es: "Ahorrar"
    },

    search: {
        pt_br: "Pesquisar",
        en_us: "Search",
        es_es: "Buscar"
    },

    seeLess: {
        pt_br: "Ver menos",
        en_us: "See less",
        es_es: "Ver menos"
    },

    seeMore: {
        pt_br: "Ver mais",
        en_us: "See more",
        es_es: "Ver más"
    },

    serviceOrder: {
        pt_br: "Ordem de serviço",
        en_us: "Service order",
        es_es: "Orden de servicio"
    },

    serviceOrderInformation: {
        pt_br: "Informações da ordem de serv.",
        en_us: "Service order informations",
        es_es: "Informaciónes de la orden de servicio"
    },

    serviceOrderLog: {
        pt_br: "Log de ordens de serviço",
        en_us: "Service orders log",
        es_es: "Registro de órdenes de servicio"
    },

    serviceOrders: {
        pt_br: "Ordens de serviço",
        en_us: "Service orders",
        es_es: "Órdenes de servicio"
    },

    serviceOrdersByTag: {
        pt_br: "Ordens de serviço por tag",
        en_us: "Service orders by tag",
        es_es: "Órdenes de servicio por tag"
    },

    serviceStatus: {
        pt_br: "Status do serviço",
        en_us: "Service status",
        es_es: "Estado del servicio"
    },

    settings: {
        pt_br: "Configurações",
        en_us: "Settings",
        es_es: "Ajustes"
    },

    shoppingCart: {
        pt_br: "Carrinho",
        en_us: "Cart",
        es_es: "Cesta"
    },

    shortcuts: {
        pt_br: "Atalhos",
        en_us: "Shortcuts",
        es_es: "Atajos"
    },

    showOnlyRoomsFromPool: {
        pt_br: "Mostrar apenas UHs do pool",
        en_us: "Show only rooms from \"pool\"",
        es_es: "Mostrar solo las habitaciones del \"pool\""
    },

    showOnlyRoomsIncludedInAvailability: {
        pt_br: "Mostrar apenas UHs que entram na disponibilidade",
        en_us: "Show only rooms that become available",
        es_es: "Mostrar solo las habitaciones que quedan disponibles"
    },

    showRemoved: {
        pt_br: "Mostrar excluídos",
        en_us: "Show removed",
        es_es: "Mostrar eliminado"
    },

    situation: {
        pt_br: "Situação",
        en_us: "Situation",
        es_es: "Situación"
    },

    sortBy: {
        pt_br: "Ordenar por",
        en_us: "Sort by",
        es_es: "Ordenar por"
    },

    spanish: {
        pt_br: "Espanhol",
        en_us: "Spanish",
        es_es: "Español"
    },

    startDate: {
        pt_br: "Data inicial",
        en_us: "Start date",
        es_es: "Fecha de inicio"
    },

    startDateToEndDate: {
        pt_br: "{startDate} até {endDate}",
        en_us: "{startDate} to {endDate}",
        es_es: "{startDate} a {endDate}"
    },

    statisticalLog: {
        pt_br: "Log estatístico",
        en_us: "Statistical log",
        es_es: "Registro estadístico"
    },

    status: {
        pt_br: "Status",
        en_us: "Status",
        es_es: "Estado"
    },

    statusStatistics: {
        pt_br: "Estatísticas por status",
        en_us: "Statistics by status",
        es_es: "Estadísticas por estado"
    },

    summary: {
        pt_br: "Resumo",
        en_us: "Summary",
        es_es: "Resumen"
    },

    sunday: {
        pt_br: "Domingo",
        en_us: "Sunday",
        es_es: "Domingo"
    },

    systemConfiguration: {
        pt_br: 'Configuração do sistema',
        en_us: 'System configuration',
        es_es: 'Configuración del sistema'
    },

    tag: {
        pt_br: 'Tag',
        en_us: 'Tag',
        es_es: 'Tag'
    },

    tags: {
        pt_br: 'Tags',
        en_us: 'Tags',
        es_es: 'Tags'
    },

    testApiConnection: {
        pt_br: 'Testar conexão com API',
        en_us: 'Test API connection',
        es_es: 'Probar la conexión API'
    },

    testDatabaseConnection: {
        pt_br: 'Testar conexão com banco de dados',
        en_us: 'Test database connection',
        es_es: 'Probar la conexión de la base de datos'
    },

    testSendingEmail: {
        pt_br: "Testar envio de e-mail",
        en_us: "Test sending email",
        es_es: "Probar el envío de correo electrónico"
    },

    thursday: {
        pt_br: "Quinta-feira",
        en_us: "Thursday",
        es_es: "Jueves"
    },

    title: {
        pt_br: "Título",
        en_us: "Title",
        es_es: "Título"
    },

    to: {
        pt_br: "Para",
        en_us: "To",
        es_es: "Para"
    },

    today: {
        pt_br: "Hoje",
        en_us: "Today",
        es_es: "Hoy"
    },

    token: {
        pt_br: "Token",
        en_us: "Token",
        es_es: "Token"
    },

    tomorrow: {
        pt_br: "Amanhã",
        en_us: "Tomorrow",
        es_es: "Mañana"
    },

    toSend: {
        pt_br: "Enviar",
        en_us: "To send",
        es_es: "Enviar"
    },

    total: {
        pt_br: "Total",
        en_us: "Total",
        es_es: "Total"
    },

    totalTime: {
        pt_br: "Tempo total",
        en_us: "Total time",
        es_es: "Tiempo total"
    },

    translationNotFound: {
        pt_br: "Tradução não encontrada",
        en_us: "Translation not found",
        es_es: "Traducción no encontrada"
    },

    tuesday: {
        pt_br: "Terça-feira",
        en_us: "Tuesday",
        es_es: "Martes"
    },

    type: {
        pt_br: "Tipo",
        en_us: "Type",
        es_es: "Tipo"
    },

    typeMessage: {
        pt_br: "Digite uma mensagem",
        en_us: "Type a message",
        es_es: "Escriba un mensaje"
    },

    undefined: {
        pt_br: "Não definido",
        en_us: "Undefined",
        es_es: "No definido"
    },

    uninformed: {
        pt_br: "Não informado",
        en_us: "Uninformed",
        es_es: "No informado"
    },

    url: {
        pt_br: "Url",
        en_us: "Url",
        es_es: "Url"
    },

    user: {
        pt_br: "Usuário",
        en_us: "User",
        es_es: "Usuario"
    },

    users: {
        pt_br: "Usuários",
        en_us: "Users",
        es_es: "Usuarios"
    },

    usersFound: {
        pt_br: "Usuários encontrados",
        en_us: "Users found",
        es_es: "Usuarios encontrados"
    },

    vacationCenterDashboard: {
        pt_br: 'Dashboard da Central de Férias',
        en_us: 'Vacation Center Dashboard',
        es_es: 'Panel del Centro de Vacaciones'
    },

    vacationCenterDashboardUrl: {
        pt_br: 'Url do dashboard da central de férias (Power BI)',
        en_us: 'Vacation center dashboard url (Power BI)',
        es_es: 'Url del panel del centro de vacaciones (Power BI)'
    },

    value: {
        pt_br: "Valor",
        en_us: "Value",
        es_es: "Valor"
    },

    video: {
        pt_br: "Vídeo",
        en_us: "Video",
        es_es: "Video"
    },

    view: {
        pt_br: "Visualizar",
        en_us: "View",
        es_es: "Vista"
    },

    vip: {
        pt_br: "VIP",
        en_us: "VIP",
        es_es: "VIP"
    },

    vipReservation: {
        pt_br: "Reserva VIP",
        en_us: "VIP reservation",
        es_es: "Reserva VIP"
    },

    viewShoppingCart: {
        pt_br: "Visualizar carrinho",
        en_us: "View cart",
        es_es: "Ver cesta"
    },

    wednesday: {
        pt_br: "Quarta-feira",
        en_us: "Wednesday",
        es_es: "Miércoles"
    },

    welcome: {
        pt_br: "Bem-vindo",
        en_us: "Welcome",
        es_es: "Bien-venido"
    },

    yes: {
        pt_br: "Sim",
        en_us: "Yes",
        es_es: "Sí"
    },

    yesterday: {
        pt_br: "Ontem",
        en_us: "Yesterday",
        es_es: "Ayer"
    }
}

export default DefaultTranslation;